<app-header></app-header>
<div class="form-wrapper">
	<div class="container">
		<div class="logo-container">
			<div class="logo-wrapper cursor-pointer" (click)="utilityService.navigate('/')">
				<img alt="tenderpilot-logo" src="../../../assets/logo/tp-logo-voll-quer.svg" width="390">
			</div>
		</div>
		<div class="form">
			<div>
				<form nz-form [formGroup]="forgotPasswordForm" class="forgot-password-form">
					<nz-form-item class="input-field">
						<nz-form-control>
							<app-input-field [size]="'large'" [nzPrefix]="prefixIconEmail" [form]="forgotPasswordForm"
								[label]="'global.login.label.email' | translate"
								[placeholder]="'global.login.placeholder.enter_email' | translate" [formName]="'email'">
							</app-input-field>
							<ng-template #prefixIconEmail>
								<i nz-icon nzType="user" nzTheme="outline"></i>
							</ng-template>
						</nz-form-control>
					</nz-form-item>
				</form>

				<div class="text-center">
					<button (click)="submitForgotPasswordForm('buyer')" nzBlock nz-button
						[disabled]="!forgotPasswordForm.valid" [nzType]="'primary'"
						class="login-form-button btn-color-default mt-0_5" style="min-height: auto">
						{{ "global.login.label.i_am_buyer" | translate}}
					</button>
					<div class="d-flex text-center vertical-align-middle center mt-0_5" id="devider">
						{{ "global.common.or" | translate}}
					</div>
					<button (click)="submitForgotPasswordForm('supplier')" nz-button nzBlock
						[disabled]="!forgotPasswordForm.valid" [nzType]="'primary'"
						class="login-form-button btn-color-default mt-0_5">
						{{ "global.login.label.i_am_supplier" | translate}}
					</button>
				</div>

				<div class="text-center mt-2" nz-button>
					<a href="auth?tab=login" class="login-form mt-0_5">
						{{ "global.forgot_password.label.back_to_sign_in" | translate }}
					</a>
				</div>
			</div>
		</div>
	</div>
</div>
<app-footer></app-footer>
